/* eslint-disable promise/param-names */
import { ADDRESS_UPDATE_REQUEST, ADDRESS_UPDATE_ERROR, ADDRESS_UPDATE_SUCCESS, ADDRESS_UPDATE_LOGOUT } from '../actions/addressUpdate'
import axios from 'axios'
import qs from 'qs'

const state = { updatedAddress: {} }

const getters = {
  getUpdatedAddress: state => state.updatedAddress,
}

const actions = {
  [ADDRESS_UPDATE_REQUEST]: ({commit, dispatch}, updatedAddress) => {
    return new Promise((resolve, reject) => {
      commit(ADDRESS_UPDATE_REQUEST)

        const data = updatedAddress;

      const headers = {
        'Content-Type': 'application/json'
      };
      axios({url: '/members/io/addresses', data, headers, method: 'POST'})
      .then(resp => {
        console.log("AddressUpdate: success");
        commit(ADDRESS_UPDATE_SUCCESS, resp)
        resolve(resp)
      })
      .catch(err => {
        console.log("AddressUpdate: error");
        commit(ADDRESS_UPDATE_ERROR, err)
        reject(err)
      })
    })
  },
  [ADDRESS_UPDATE_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(ADDRESS_UPDATE_LOGOUT)
      resolve()
    })
  }
}

const mutations = {
  [ADDRESS_UPDATE_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [ADDRESS_UPDATE_SUCCESS]: (state, updatedAddress) => {
    state.status = 'success'
    //Vue.set(state, 'documents', resp.data)
    state.updatedAddress = updatedAddress
  },
  [ADDRESS_UPDATE_ERROR]: (state) => {
    state.status = 'error'
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
